/* HUSHLY — bloc d'achat : miniatures, choix du pack, ajout au panier sans quitter la page */
(function(){
  function init(root){
    (root || document).querySelectorAll('.hb').forEach(function(sec){
      if (sec.dataset.hbReady === '1') return;
      sec.dataset.hbReady = '1';

      /* miniatures */
      var thumbs = sec.querySelector('.hb-thumbs');
      if (thumbs){
        var main = document.getElementById(thumbs.dataset.main);
        thumbs.addEventListener('click', function(e){
          var b = e.target.closest('.hb-thumb'); if (!b || !main) return;
          main.src = b.dataset.src;
          thumbs.querySelectorAll('.hb-thumb').forEach(function(x){ x.classList.remove('is-on'); });
          b.classList.add('is-on');
        });
      }

      /* choix du pack : on recopie la variante choisie dans le champ du formulaire */
      var form = sec.querySelector('[data-hb-form]'); if (!form) return;
      var idField = form.querySelector('[data-hb-id]');
      var checked = form.querySelector('input[type=radio]:checked');
      if (checked) idField.value = checked.value;
      form.addEventListener('change', function(e){
        if (e.target.type === 'radio') idField.value = e.target.value;
      });

      /* ajout au panier sans recharger */
      var btn = form.querySelector('.hb-cta');
      var label = btn ? btn.textContent : '';
      form.addEventListener('submit', function(e){
        if (!window.fetch) return;              /* sans fetch, on laisse le POST classique */
        e.preventDefault();
        /* T29 : le libelle a restaurer est celui du MOMENT (il porte le prix du pack
           choisi), pas celui du chargement, qui affichait le prix du pack 1. */
        var before = btn.textContent;
        btn.disabled = true; btn.textContent = '…';
        /* T29 : test consommateur. Seul l'id partait : l'age des oreillers 2 a 4 et
           l'age et le motif des housses offertes tombaient a la trappe. FormData
           ignore deja les champs desactives (paliers non choisis). */
        var item = { id: Number(idField.value), quantity: 1 };
        var props = {};
        try {
          new FormData(form).forEach(function(v, k){
            var m = /^properties\[(.+)\]$/.exec(k);
            if (m && v !== '') props[m[1]] = v;
          });
        } catch (err) {}
        if (Object.keys(props).length) item.properties = props;
        var drawer = document.querySelector('cart-drawer');
        var payload = { items: [item] };
        if (drawer && typeof drawer.renderContents === 'function') {
          payload.sections = ['cart-drawer', 'cart-icon-bubble'];
          payload.sections_url = window.location.pathname;
        }
        fetch('/cart/add.js', {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify(payload)
        })
        .then(function(r){ return r.json().then(function(d){ return {ok:r.ok, d:d}; }); })
        .then(function(res){
          if (!res.ok) throw new Error(res.d.description || res.d.message || 'refus');
          btn.textContent = sec.dataset.added || 'Added';
          document.dispatchEvent(new CustomEvent('hushly:cart:added'));
          /* T29 : le tiroir etait rendu au chargement et jamais rafraichi : l'icone
             panier ouvrait un panier VIDE juste apres l'ajout. On le re-rend avec la
             reponse, et Dawn l'ouvre ensuite, exactement comme depuis la fiche. */
          if (res.d && res.d.sections && drawer && typeof drawer.renderContents === 'function') {
            /* T31 : comme product-form.js de Dawn, on retire is-empty du tiroir AVANT de
               le rendre. Sinon, a l'ouverture, Dawn cherche le bloc « panier vide » qui
               n'existe plus, trapFocus(null) leve une erreur et le focus n'est pas piege. */
            try { drawer.classList.remove('is-empty'); drawer.renderContents(res.d); return; } catch (err) { console.warn('[hushly-buybox] tiroir', err); }
          }
          /* on rafraichit le compteur du panier si le theme en expose un */
          return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
            document.querySelectorAll('.cart-count-bubble span:first-child').forEach(function(el){
              el.textContent = cart.item_count;
            });
            var bub = document.querySelector('.cart-count-bubble');
            if (!bub){
              var icon = document.querySelector('#cart-icon-bubble');
              if (icon && cart.item_count > 0){
                var s = document.createElement('div'); s.className = 'cart-count-bubble';
                s.innerHTML = '<span aria-hidden="true">' + cart.item_count + '</span>';
                icon.appendChild(s);
              }
            }
          });
        })
        .catch(function(err){ btn.textContent = (sec.dataset.error || 'Try again'); console.warn('[hushly-buybox]', err); })
        .then(function(){ setTimeout(function(){ btn.disabled = false; btn.textContent = before || label; }, 1800); });
      });
    });
  }
  if (document.readyState === 'loading') addEventListener('DOMContentLoaded', function(){ init(); }, {once:true});
  else init();
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();

/* 10/09 hkOffersAnchor : le bouton « Shop Now » pointe sur /#offers. La page d accueil est longue
   et ses sections se posent apres le premier rendu : le saut natif du navigateur arrive trop tot
   et reste en haut. On refait le calage apres la mise en page, puis une fois de plus au chargement
   complet, et on gere le clic quand on est deja sur l accueil. */
(function(){
  var CIBLE='offers';
  function cale(doux){
    var el=document.getElementById(CIBLE); if(!el) return false;
    el.scrollIntoView({behavior:doux?'smooth':'auto',block:'start'});
    return true;
  }
  function depuisHash(){
    if(location.hash!=='#'+CIBLE) return;
    requestAnimationFrame(function(){ cale(false); });
    setTimeout(function(){ cale(false); },450);
    window.addEventListener('load',function(){ setTimeout(function(){ cale(false); },250); },{once:true});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',depuisHash);
  else depuisHash();
  window.addEventListener('hashchange',function(){ if(location.hash==='#'+CIBLE) cale(true); });
  document.addEventListener('click',function(e){
    var a=e.target.closest && e.target.closest('a[href$="#'+CIBLE+'"]');
    if(!a) return;
    var u=new URL(a.href,location.href);
    if(u.pathname!==location.pathname) return;      /* autre page : navigation normale */
    if(!document.getElementById(CIBLE)) return;
    e.preventDefault();
    if(location.hash!=='#'+CIBLE) history.pushState(null,'','#'+CIBLE);
    cale(true);
  });
})();

/* 10/09 hkBuyAnchor : les liens vers #buy (CTA « Choose my child's size » du bloc garantie)
   remontent vers la galerie produit, avec un decalage pour l en-tete collant. */
(function(){
  function cible(){
    return document.querySelector('media-gallery, .product__media-wrapper, .product__media-list, [data-hb-track]')
        || document.getElementById('buy');
  }
  function decalage(){ return Math.min(112, Math.max(72, innerWidth*0.14)); }
  function cale(doux){
    var el=cible(); if(!el) return;
    var y=el.getBoundingClientRect().top+window.scrollY-decalage();
    window.scrollTo({top:y<0?0:y, behavior:doux?'smooth':'auto'});
  }
  document.addEventListener('click',function(e){
    var a=e.target.closest && e.target.closest('a[href$="#buy"]');
    if(!a) return;
    var u; try{ u=new URL(a.href,location.href); }catch(err){ return; }
    if(u.pathname!==location.pathname) return;
    if(!cible()) return;
    e.preventDefault();
    if(location.hash!=='#buy') history.pushState(null,'','#buy');
    cale(true);
  });
  function auChargement(){ if(location.hash!=='#buy') return;
    requestAnimationFrame(function(){cale(false);});
    setTimeout(function(){cale(false);},450);
    window.addEventListener('load',function(){ setTimeout(function(){cale(false);},250); },{once:true});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',auChargement); else auChargement();
  window.addEventListener('hashchange',function(){ if(location.hash==='#buy') cale(true); });
})();


/* ------------------------------------------------------------------
   T28 (11/09/2026). LES AGES SUIVENT LE 1ER OREILLER.
   Test consommateur : le parent choisit « 3 to 8 years » puis le pack 3 ; les
   selecteurs des oreillers 2 et 3 s'activaient sur la PREMIERE valeur de la
   liste (« 1 to 3 years »), la housse offerte aussi. La commande partait avec
   deux oreillers et une housse de la mauvaise taille, sans que rien ne l'affiche.
   Regle : tant que le parent n'a pas touche un selecteur (oreiller 2 a 4) ou une
   carte de housse, ils recopient l'age du 1er oreiller, a chaque changement
   d'age ou de palier. Des qu'il les touche (freres et soeurs d'ages differents),
   son choix est garde. Meme code sur la fiche et sur le bloc de l'accueil.
   ------------------------------------------------------------------ */
(function () {
  if (window.__hkAgeMirror) return;
  window.__hkAgeMirror = true;
  function esc(v) { return (window.CSS && CSS.escape) ? CSS.escape(v) : String(v).replace(/"/g, '\\"'); }
  function firstSel(b) {
    return b.querySelector('select[data-hb-age]') || b.querySelector('select.hb-age__s:not([data-hb-ageprop])');
  }
  function mirror(b) {
    var f = firstSel(b);
    if (!f || !f.value) return;
    var v = f.value;
    Array.prototype.forEach.call(b.querySelectorAll('select[data-hb-ageprop]'), function (s) {
      if (s.hasAttribute('data-hb-touched')) return;
      if (Array.prototype.some.call(s.options, function (o) { return o.value === v; })) s.value = v;
    });
    /* 27/09/2026 : une housse par oreiller, la housse N prend la taille de l'oreiller N
       (celle du 1er tant que l'oreiller N n'en a pas). Meme code que hushly-pdp-buybox.js. */
    Array.prototype.forEach.call(b.querySelectorAll('[data-hb-covcard]'), function (card) {
      if (card.hasAttribute('data-hb-touched')) return;
      var cn = card.getAttribute('data-hb-covcard'), vv = v;
      var ps = cn && cn !== '1' ? b.querySelector('select[data-hb-ageprop="' + cn + '"]') : null;
      if (ps && !ps.disabled && ps.value) vv = ps.value;
      var chip = card.querySelector('[data-hb-covchip][data-val="' + esc(vv) + '"]');
      if (!chip) return;
      Array.prototype.forEach.call(card.querySelectorAll('[data-hb-covchip]'), function (x) {
        x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false');
      });
      chip.classList.add('is-on'); chip.setAttribute('aria-pressed', 'true');
      var inp = card.querySelector('[data-hb-covprop]');
      if (inp) inp.value = vv;
    });
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b = t.closest('.hb');
    if (!b) return;
    if (t.matches('select[data-hb-ageprop]')) t.setAttribute('data-hb-touched', '1'); /* 27/09 : et la housse du meme numero suit */
    setTimeout(function () { mirror(b); }, 0);
  }, true);
  document.addEventListener('click', function (e) {
    var chip = e.target && e.target.closest && e.target.closest('[data-hb-covchip]');
    if (!chip) return;
    var card = chip.closest('[data-hb-covcard]');
    if (card) card.setAttribute('data-hb-touched', '1');
  }, true);
  function init() { Array.prototype.forEach.call(document.querySelectorAll('.hb'), mirror); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


/* ------------------------------------------------------------------
   T11 (12/09/2026). BLOC D'ACHAT HORS FICHE : PAS D'AJOUT SANS AGE.
   Releve vitrine : sur l'accueil et sur /pages/our-story le selecteur
   arrivait sur « 1 to 3 years » et le bouton etait actif. Un parent qui
   n'y touchait pas commandait la mauvaise hauteur.
   Le gabarit pose maintenant une premiere option VIDE « Select their age »,
   selectionnee, sur le 1er oreiller et sur les oreillers 2 a 4 des packs,
   exactement comme la fiche produit. Ce bloc ferme la porte de sortie :
   tant qu'un age actif reste vide, le clic sur le bouton et l'envoi du
   formulaire sont arretes, le message « Choose an age first » parait et la
   page redescend sur le champ qui manque. Rien n'est retire : le bouton
   reste en place, il refuse seulement de partir incomplet.
   La fiche produit a sa propre barriere (hushly-pdp-buybox.js, racine
   .hb-pdp) : on l'ignore ici pour ne pas poser deux gardes sur le meme clic.
   ------------------------------------------------------------------ */
(function () {
  if (window.__hkAgeGateHome) return;
  window.__hkAgeGateHome = true;

  function elem(n) { while (n && n.nodeType !== 1) n = n.parentNode; return n; }

  function leFormulaire(n) {
    n = elem(n);
    var f = n && n.closest ? n.closest('form[data-hb-form]') : null;
    if (!f || f.closest('.hb-pdp')) return null;   /* la fiche se garde elle-meme */
    return f;
  }

  /* premier champ d'age actif et vide, ou null si tout est renseigne */
  function manque(f) {
    var un = f.querySelector('select[data-hb-age]');
    if (un && !un.disabled && !un.value) return un;
    var trouve = null;
    Array.prototype.some.call(f.querySelectorAll('select[data-hb-ageprop]'), function (s) {
      if (!s.disabled && !s.value) { trouve = s; return true; }
      return false;
    });
    return trouve;
  }

  function note(f) { return f.querySelector('[data-hb-agenote]'); }

  function signaler(f, m) {
    var n = note(f);
    if (n) n.hidden = false;
    var cible = m || f.querySelector('[data-hb-agewrap]') || f;
    var doux = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var y = cible.getBoundingClientRect().top + window.scrollY - 120;
    try { window.scrollTo({ top: Math.max(0, y), behavior: doux ? 'smooth' : 'auto' }); }
    catch (e) { window.scrollTo(0, Math.max(0, y)); }
    if (cible.focus) { try { cible.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* barriere 1 : le clic sur le bouton, en capture, avant le script du bloc */
  document.addEventListener('click', function (e) {
    var t = elem(e.target);
    if (!t || !t.closest || !t.closest('[data-hb-cta]')) return;
    var f = leFormulaire(t); if (!f) return;
    var m = manque(f); if (!m) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    signaler(f, m);
  }, true);

  /* barriere 2 : l'envoi du formulaire, quelle qu'en soit l'origine */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[data-hb-form]')) return;
    if (f.closest('.hb-pdp')) return;
    var m = manque(f); if (!m) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    signaler(f, m);
  }, true);

  /* le message repart des que le manque est comble */
  document.addEventListener('change', function (e) {
    var t = elem(e.target);
    if (!t || !t.matches || !t.matches('select[data-hb-age], select[data-hb-ageprop]')) return;
    var f = leFormulaire(t); if (!f) return;
    var n = note(f);
    if (n && !manque(f)) n.hidden = true;
  });
})();

/* HUSHLY 22/09/2026 : meme ancrage que sur la fiche (hushly-pdp-buybox.js), pour le bloc offres de l'accueil.
   Le pack touche reste sous le doigt.
   En changeant de pack, la carte ouverte au-dessus (ses ages, ses housses) se referme : tout remonte de
   200 a 400 px et la carte touchee sortait parfois de l'ecran. On mesure sa position au moment du clic
   et on compense le defilement pendant que la page se recompose (Dawn re-rend en ~200 ms). */
(function () {
  if (window.__hkPackAnchor) return; window.__hkPackAnchor = true;
  var last = 0;
  document.addEventListener('click', function (e) {
    var card = e.target && e.target.closest && e.target.closest('[data-hb-pk], .hb-pk');
    if (!card) return;
    var now = Date.now();
    if (now - last < 350) return;          /* label + radio = deux clics pour un seul geste */
    last = now;
    var y0 = card.getBoundingClientRect().top;
    function fix() {
      var d = card.getBoundingClientRect().top - y0;
      if (Math.abs(d) > 2) window.scrollBy(0, d);
    }
    requestAnimationFrame(fix);
    [80, 220, 450, 800].forEach(function (ms) { setTimeout(fix, ms); });
  }, true);

  /* Clavier (fleches sur les packs) : Dawn re-rend le bloc et le focus tombait hors des packs.
     On garde la carte en place et on rend le focus au pack choisi, sans faire defiler. */
  var kbAt = 0;
  document.addEventListener('keydown', function (e) {
    if (/^Arrow/.test(e.key) && e.target && e.target.closest && e.target.closest('[data-hb-pk], .hb-pk')) kbAt = Date.now();
  }, true);
  document.addEventListener('change', function (e) {
    var card = e.target && e.target.closest && e.target.closest('[data-hb-pk], .hb-pk');
    if (!card || !kbAt || Date.now() - kbAt > 1000) return;
    kbAt = 0;
    var y0 = card.getBoundingClientRect().top;
    function keep() {
      var d = card.getBoundingClientRect().top - y0;
      if (Math.abs(d) > 2) window.scrollBy(0, d);
      var r = card.querySelector('input[type=radio]');
      var a = document.activeElement;
      if (r && a !== r && (!a || a === document.body || !a.closest || !a.closest('[data-hb-pk], .hb-pk'))) {
        try { r.focus({ preventScroll: true }); } catch (x) {}
        d = card.getBoundingClientRect().top - y0;
        if (Math.abs(d) > 2) window.scrollBy(0, d);
      }
    }
    requestAnimationFrame(keep);
    [80, 220, 450, 800].forEach(function (ms) { setTimeout(keep, ms); });
  }, true);
})();

/* 22/09/2026 : meme garde que la fiche produit (bloc offres de l'accueil), par precaution si un bouton
   de paiement express y est ajoute un jour. */
/* 21/09/2026 (Antonin) : GARDE PAIEMENT EXPRESS.
   Apple Pay, Shop Pay et Google Pay (accelerated checkout) envoient les champs properties[]
   MEME quand ils sont desactives : panier #52454912524624 = 1 oreiller + 11 notes (ages des
   oreillers 2 a 4, 4 housses offertes). Reproduit au Shop Pay le 21/09. Le panier classique,
   lui, respecte disabled. Donc : un champ properties[] desactive perd son name (garde dans
   data-hb-pname) et le retrouve des qu il est reactive. Rien d autre ne cherche ces champs par name. */
(function(){
  if(window.__hkExpressGuard) return; window.__hkExpressGuard=true;
  var SEL='[name^="properties["],[data-hb-pname]';
  function g(el){
    if(!el||el.nodeType!==1) return;
    var n=el.getAttribute('name'), s=el.getAttribute('data-hb-pname');
    if(el.disabled){
      if(n&&n.indexOf('properties[')===0){ el.setAttribute('data-hb-pname',n); el.removeAttribute('name'); }
    } else if(!n&&s){ el.setAttribute('name',s); }
  }
  function tout(){ [].forEach.call(document.querySelectorAll(SEL),g); }
  tout();
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',tout,{once:true});
  new MutationObserver(function(ms){
    ms.forEach(function(m){
      if(m.type==='attributes'){ g(m.target); return; }
      [].forEach.call(m.addedNodes,function(x){ if(x.querySelectorAll){ g(x); [].forEach.call(x.querySelectorAll(SEL),g); } });
    });
  }).observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled']});
})();
